import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { filesCopyIcons } from '../../../common/Icons';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../../../../store/reducers';
import { Actions } from '../../../../store/actions';
import { copyOpFgpCopyFrom, OP_FGP_COPY_FROM } from '../../../../store/actions/prescriptionPad';
import { List, notification, Popover } from 'antd';
import {
    getLastFinalGlassPrescription,
    setLastFinalGlassPrescription,
} from '../../../../store/localstorage';

type Props = {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
};

type State = {
    copyFrom?: OP_FGP_COPY_FROM;
};

class OpthalCopyFrom extends PureComponent<Props, State> {
    state: State = { copyFrom: getLastFinalGlassPrescription() as OP_FGP_COPY_FROM };

    onCopyFromChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        if (e.target.value === '-') {
            this.setState({ copyFrom: undefined });
            return;
        }
        this.setState({ copyFrom: e.target.value as OP_FGP_COPY_FROM });
        setLastFinalGlassPrescription(e.target.value);
    };

    onCopy = (copyFrom: OP_FGP_COPY_FROM): void => {
        if (copyFrom || this.state.copyFrom) {
            this.props.dispatch(copyOpFgpCopyFrom(copyFrom || this.state.copyFrom));
        } else {
            notification.error({
                message: 'Please select from where to copy',
                duration: 2,
            });
        }
    };

    render(): ReactNode {
        return (
            <div className="space-x-4">
                <Popover
                    content={
                        <List
                            itemLayout="horizontal"
                            dataSource={[
                                {
                                    title: 'Dilated Subjective Refraction',
                                    key: 'dsr',
                                },
                                {
                                    title: 'Undilated Subjective Refraction',
                                    key: 'usr',
                                },
                                {
                                    title: 'Dilated Auto Refraction',
                                    key: 'dar',
                                },
                                {
                                    title: 'Undilated Auto Refraction',
                                    key: 'uar',
                                },
                                {
                                    title: 'Current glass precription',
                                    key: 'cgp',
                                },
                            ]}
                            renderItem={(item) => (
                                <List.Item
                                    onClick={() => this.onCopy(item.key as OP_FGP_COPY_FROM)}
                                    className="cursor-pointer"
                                >
                                    <span>{item.title}</span>
                                </List.Item>
                            )}
                        />
                    }
                >
                    <button className="secondary-btn px-8 py-4 body-2 space-x-8 font-400 space-x-4">
                        <span>Copy</span> {filesCopyIcons()}
                    </button>
                </Popover>
            </div>
        );
    }
}

export default connect()(OpthalCopyFrom);
